import React from 'react';

interface PasswordStrengthMeterProps {
  readonly score: number;
  readonly className?: string;
}

const strengthLevels = [
  { label: 'Very Weak', color: '#E71111' },
  { label: 'Weak', color: '#EA5A0A' },
  { label: 'Ok', color: '#EFA00B' },
  { label: 'Strong', color: '#41D3BD' },
  { label: 'Very Strong', color: '#07BD71' }
];

const defaultGrey = '#6A6A6A';

function PasswordStrengthMeter({
  score,
  className
}: Readonly<PasswordStrengthMeterProps>): React.ReactElement {
  const currentStrengthLevel = strengthLevels[score - 1];

  return (
    <div className={className}>
      <div className='flex gap-1 h-0.5 my-1'>
        {strengthLevels.map((level, index) => (
          <div
            key={level.label}
            className='flex-1'
            style={{
              backgroundColor:
                score > 0 && index + 1 <= score
                  ? currentStrengthLevel?.color
                  : defaultGrey
            }}
          />
        ))}
      </div>
      <div
        className='text-right'
        style={{ color: currentStrengthLevel?.color ?? defaultGrey }}
      >
        <p className='text-xs'>{score > 0 && currentStrengthLevel?.label}</p>
      </div>
    </div>
  );
}

export default PasswordStrengthMeter;
